import { Container, Paper, makeStyles, Grid, Button } from "@material-ui/core";
import { CardsGridForComments } from '../CardsGrid/CardsGrid';
import emerjLogo from './EMERJLOGO.svg';
import pjerj from './TJRJLOGO.svg';
import coemLogo from './COEMLOGO.svg';
import ceditecLogo from './CEDITECLOGO.svg';
import ufrjFnd from './UFRJFND.svg';
import Phone from './CelularComVideo.mp4';
import Bndes from '../../../sharedImgs/logo_bndes_1.svg';

export default function MariaPenhaCase() {

    const useStyles = makeStyles((theme) => ({
        root: {
            display: "flex",
            "@media (max-width: 576px)": {
                flexDirection: "column"
            },
            "@media (max-width: 720px)": {
                flexDirection: "column"
            },
            "@media (max-width: 1150px)": {
                flexDirection: "column"
            },
            "@media (max-width: 1300px)": {
                flexDirection: "column"
            },
        },
        video: {
            "@media (max-width: 1000px)": {
                width: '290px',
                height: '290px'
            },
            "@media (min-width: 1001px)": {
                width: '370px',
                height: '370px'
            },
            "@media (min-width: 1300px)": {
                width: '420px',
                height: '420px'
            },
        },
        descriptionDiv: {
            padding: "30px",
            alignSelf: 'center'
        },
        lastMessage: {
            alignContent: 'center',
            display: 'inline',
            alignSelf: 'center'
        },
        divIcons: {
            textAlign: 'center'
        },
        buttonText: {
            textDecoration: 'none',
            color: '#838383'
        },
        ceditecLogo: {
            paddingLeft: '5px'
        },
        emerjLogo: {
            paddingBottom: '10px'
        },
        pjerj: {

        },
        coemLogo: {
            paddingBottom: '30px',
            paddingLeft: '5px'
        },
        ufrjFnd: {
            paddingLeft: '5px'
        },
        partners: {
            paddingTop: '10px'
        },
        bndes: {
            width: 165,
            height: 165
        }
    }));
    const classes = useStyles();

    return (
        <Container>
            <Container style={{ boxShadow: '0px 4px 30px #FBEAFF', padding: '0' }}>
                <Container style={{ backgroundColor: '#FFF2F9', marginTop: '100px', padding: '16px' }} className={classes.root}>
                    <div>
                        <video className={classes.video} controls >
                            <source src={Phone} type={"video/mp4"} />
                        </video>
                    </div>
                    <div className={classes.descriptionDiv}>
                        <h1>Maria da penha Virtual</h1>
                        <p> O aplicativo web que concretiza o acesso à justiça pela automatização do pedido de medida protetiva para as mulheres em situação de violência, de maneira ágil, eficiente e desburocratizada</p>
                        <a target="_blank" rel="noreferrer" href="https://www3.tjrj.jus.br/mariapenhavirtual/" className={classes.buttonText}><Button variant="contained" style={{ backgroundColor: '#E65E8D', color: "#ffffff", height: "60px", width: '180px' }}>Conheça mais</Button></a>
                    </div>
                </Container>
                <Paper style={{ boxShadow: 'none' }}>
                    <Grid className={classes.divIcons}>
                        <p style={{ marginTop: '0', fontWeight: 'bold' }} className={classes.partners}>Parceiros do projeto</p>
                        <img className={classes.emerjLogo} src={emerjLogo} alt="Logo da EMERJ" />
                        <img className={classes.pjerj} src={pjerj} alt="Logo do Tribunal de Justiça do Rio de Janeiro, TJRJ" />
                        <img className={classes.coemLogo} src={coemLogo} alt="Logo da COEM, coordenadoria estadual da mulher" />
                        <img className={classes.ceditecLogo} src={ceditecLogo} alt="Logo da CEDITEC" />
                        <img className={classes.ufrjFnd} src={ufrjFnd} alt="Logo da Faculdade UFRJ" />
                        <img className={classes.bndes} src={Bndes} alt="Logo da BNDES Garagem" />
                    </Grid>
                </Paper>
            </Container>
            <p style={{ fontWeight: 'bold', marginTop: '100px' }}>Mais de 900 pedidos de medida protetiva feitas pelo aplicativo <p style={{ fontWeight: 'lighter', fontSize: 10 }} >(Números oficiais de Setembro de 2021)</p><br></br>
                Veja alguns depoimentos de vítimas beneficiadas pelo Maria da Penha Virtual </p>
            <CardsGridForComments />
        </Container>
    )
}